﻿import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { AlarmLimitGroupFormatter } from "../../Formatters/AlarmLimitGroupFormatter";
import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { ILiveDataListenerContext, ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { ProfileComponent } from "../../ValueTypes/Profile";
import { WaveSpectrum } from "../../ValueTypes/WaveSpectrum";
import { DirectionalPolarChart } from "./DirectionalPolarChart";
import { ChartDataPoint, HovmollerChart } from "./HovmollerChart";
import { ISiteObservationsPage } from "./ISiteObservationsPage";
import { PolarWaveChart } from "./PolarWaveChart";
import { ValueBox } from "./ValueBox";
import { WaveSpectrumChart } from "./WaveSpectrumChart";

export class Waves implements ISiteObservationsPage {

    public EXCURSION_PARAM_ID = 'Buoy_Excursion/m';
    public LATITUDE_PARAM_ID = 'Buoy_Latitude/deg';

    public id: string = 'waves';
    public label: string = 'Waves';

    public station: ParameterSchemaStation;
    public warningGroup: WarningGroup;

    private _chartsHovmoller: HovmollerChart;
    private currentProfileSensor?: string = null; //: for Hovmöller chart..
    private currentProfileParam?: string = null; //: for Hovmöller chart..

    public show(station: ParameterSchemaStation): boolean | ISiteObservationsPage[] {
        
        const pages = [];

        // Go through all sensorIds
        for (let sensorId in station.Sensors) {

            // if not useLiveData or forecast, skip
            if (!station.Sensors[sensorId].UseLiveData || sensorId.toLowerCase().includes('forecast')) {
                continue;
            }

            const sensor = station.Sensors[sensorId];
            if (sensorId.includes("orecast")) {
                continue;
            }

            // Check if the sensorId has any wave Hs (wave) parameters. If so, generate a Waves-pages for this sensorId
            for (let paramId in sensor.Parameters) {
                if (paramId.indexOf('HsT/') != -1 || paramId.indexOf('Hs/') != -1) {
                    const label = station.Sensors[sensorId].SensorDefinition?.DisplayName ?? sensorId;
                    pages.push(new Waves(this.mainSite, this.ctx, sensorId, label));
                    break;
                }
            }
        }

        if (pages.length == 1) {
            return true;
        } else if (pages.length > 1) {
            return pages;
        }
        return false;
    }

    public notifyResize() {
    }

    constructor(public mainSite: MainSite, private ctx: ILiveDataListenerContext, private sensorId: string, label: string) {

        // if sensorId is not set to null, update label and id to distinguish the pages
        if (this.sensorId !== null) {
            this.label += ` (${label})`
            this.id += `${this.sensorId}`
        }

    }

    public render(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation, warningGroup: WarningGroup): void {
        this.station = station;
        this.warningGroup = warningGroup;

        if (this.mainSite.basicViewSelectorBool) {
            this.renderBasic(container, listeners);
        } else {
            this.renderAdvanced(container, listeners);
        }
    }

    public renderAdvanced(container: JQuery, listeners: ILiveDataListener[]): void {

        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');

        var leftPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '48em')
            .css('width', '31em')
            .appendTo(page);

        var rightPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '48em')
            .css('left', '33em')
            .css('width', '31em')
            .appendTo(page);

        let chartSelectTabs = $('<div class="current_chart_selector"></div>')
            .appendTo(rightPanel);

        let spectrumBox = $('<div class="site-obs-waves-charts" data-chart-type="spectrum"></div>').appendTo(rightPanel).hide();         
        let polarSpectrumBox = $('<div class="site-obs-waves-charts" data-chart-type="polar-spectrum"></div>').appendTo(rightPanel).hide();
        let polarBox = $('<div class="site-obs-waves-charts" data-chart-type="polar"></div>').appendTo(rightPanel).hide();
        let hovmollerBox = $('<div class="site-obs-waves-charts" data-chart-type="hovmoller"><em class="text-muted">Loading Hovmöller chart...</em></div>').appendTo(rightPanel).hide();

        let showChart = (chartType: string) => {
            /*spectrumBox.hide();
            polarSpectrumBox.hide();
            polarBox.hide();
            hovmoller01Box.hide();*/
            $('.site-obs-waves-charts').hide();
            $(`.site-obs-waves-charts[data-chart-type="${chartType}"]`).show();
            MainSite.instance.dispatchResize();
        };

        if (this.station.Station.Id == 'Gibraltar_GasnorBuoy') {
            listeners.push(
                new WaveSpectrumChart(this,
                    spectrumBox,
                    5, 0, 55, 100));

            listeners.push(
                new PolarWaveChart(this,
                    polarSpectrumBox,
                    5, 0, 58, 100));

            listeners.push(
                new DirectionalPolarChart(this.mainSite,
                    this,
                    polarBox,
                    4, 0, 58, 100,
                    ParameterGroupInfoSet.Hs_m.Id, ParameterGroupInfoSet.MeanWaveDirection_deg.Id,
                    true,
                    this.sensorId,
                ));
        } else {
            listeners.push(
                new WaveSpectrumChart(this,
                    spectrumBox,
                    5, 0, 55, 98));       

            listeners.push(
                new DirectionalPolarChart(this.mainSite,
                    this,
                    polarBox,
                    4, 0, 58, 100,
                    ParameterGroupInfoSet.Hs_m.Id, ParameterGroupInfoSet.MeanWaveDirection_deg.Id,
                    true,
                    this.sensorId,
                ));
        }

        if (this.sensorId == null) {
            // search through available sensors and use the first one that had a "WaveSpectrum" or "WaveSpectrum/30min" parameter
            for (const sensorId in this.station.Sensors) {
                const sensor = this.station.Sensors[sensorId];
                if (Object.keys(sensor.Parameters).some(pid => pid == "WaveSpectrum")) {
                    this.currentProfileSensor = sensorId;
                    this.currentProfileParam = "WaveSpectrum";
                    break;
                }
                if (Object.keys(sensor.Parameters).some(pid => pid == "WaveSpectrum/30min")) {
                    this.currentProfileSensor = sensorId;
                    this.currentProfileParam = "WaveSpectrum_30min";
                    break;
                }
            }
        } else {
            // use the specified sensor

            const sensor = this.station.Sensors[this.sensorId];

            if (Object.keys(sensor.Parameters).some(pid => pid == "WaveSpectrum")) {
                this.currentProfileParam = "WaveSpectrum";
            }
            if (Object.keys(sensor.Parameters).some(pid => pid == "WaveSpectrum/30min")) {
                this.currentProfileParam = "WaveSpectrum_30min";
            }
        }

        let hovmolOptions: __Highcharts.Options = HovmollerChart.chartOptionsDefault();
        hovmolOptions.tooltip = {
            headerFormat: 'Spectral Density (m² / Hz)<br/>',
            pointFormat: '{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.2f} Hz</em>): <b>{point.value:.4f}</b>' //: https://api.highcharts.com/class-reference/Highcharts.Time#dateFormat
        };
        hovmolOptions.yAxis = {
            ...hovmolOptions.yAxis,
            title: {
                text: 'Frequency (Hz)'
            },
            reversed: false,
        };
        hovmolOptions.colorAxis = {
            ...hovmolOptions.colorAxis,
            stops: [
                // Jet colorscheme
                [0, '#0000FF'], // Blue
                [0.33, '#00FFFF'], // Cyan
                [0.66, '#FFFF00'], // Yellow
                [1, '#FF0000'] // Red
            ],
        };

        this._chartsHovmoller = new HovmollerChart(
            this.mainSite,
            this,
            hovmollerBox,
            0, 0, 93, 100,
            //// specific chart options
            hovmolOptions,
            undefined,
            //// getDataMethod
            (tsFrom: moment.Moment, tsTo: moment.Moment, isSpeed: boolean, extractProfileCmpValue: (cp: ProfileComponent) => number, chart: HovmollerChart, callback: (data: ChartDataPoint[], isFailed: boolean) => void): void => {
                let res: ChartDataPoint[] = [];

                /*if (!this.mainSite.liveDataManager.latestData) {
                    console.warn('Current Hovmoller chart: waiting for live data..');
                    callback([], true);
                    return;
                }*/

                if (this.currentProfileSensor == null || this.currentProfileParam == null) {
                    console.warn('Wave Hovmoller chart: no wave spectrum sensor or param detected for this station.');
                    callback([], false);
                    return;
                }

                let sensor = this.currentProfileSensor;
                let parameter = this.currentProfileParam;
                let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
                console.info('Wave Hovmoller - data fetch URI:', uri);

                $.ajax(uri + '', {
                    cache: false,
                    dataType: 'json',
                    type: 'GET',
                    timeout: 30000,
                    success: (data: any, text: string, jqXHR: JQueryXHR) => {
                        try {
                            console.info('Wave obs - Hovmöller chart data (RAW)', data);
                            // throw new Error('dev interrupt');

                            if (Array.isArray(data.results[0].series[0].values)) {
                                for (let i = 0; i < data.results[0].series[0].values.length; i++) {
                                    let x = data.results[0].series[0].values[i];
                                    let m: moment.Moment = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                    if (m && m.isValid()) {
                                        let spectrum = JSON.parse(x[1]) as WaveSpectrum;

                                        let components = spectrum.Components.sort((a, b) => b.CentralFrequency - a.CentralFrequency); //: TODO: check sorting!!
                                        components.forEach((cp, cpi) => {
                                            if (!cp.SpectralDensity || isNaN(cp.SpectralDensity)) {
                                                return;
                                            }

                                            res.push({
                                                timestamp: m.valueOf(),
                                                y: cp.CentralFrequency,
                                                val: cp.SpectralDensity,
                                            });
                                        });
                                    } else {
                                        console.warn("Unable to parse " + this.currentProfileParam + " Spectrum Data from server response. Error: Timestamp not parseable to a valid Moment.");
                                        // this.drawChartMessage("Error while retrieving " + this.profileName + " Profile Data.");
                                    }
                                }

                                console.info('Wave obs - Hovmöller chart data', res);
                                callback(res, false);
                            }
                        } catch (err) {
                            console.warn("Unable to parse " + this.currentProfileParam + " Spectrum Data from server response. Error: ", err);
                            callback([], true);
                        }
                    },
                    error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                        console.warn("Unable to parse " + this.currentProfileParam + " Spectrum Data from server response. Error: ", errorThrown);
                        callback([], true);
                    }
                });
            },
            undefined,
            "Period (s)"
        );
        listeners.push(this._chartsHovmoller);

        let tpul = $('<ul></ul>')
            .append($('<span></span>').text("Chart: "))
            .appendTo(chartSelectTabs);

        tpul.append($('<li></li>')
            .text("Spectrum")
            .click((ev) => {
                tpul.children('li').removeClass('selected');
                $(ev.target).addClass("selected");
                /*polarBox.hide();
                polarSpectrumBox.hide();
                spectrumBox.show();
                MainSite.instance.dispatchResize();*/
                showChart('spectrum');
            }));

        if (this.station.Station.Id == 'Gibraltar_GasnorBuoy') {
            tpul.append($('<li></li>')
                .text("Polar Spectrum")
                .click((ev) => {
                    tpul.children('li').removeClass('selected');
                    $(ev.target).addClass("selected");
                    /*spectrumBox.hide();
                    polarBox.hide();
                    polarSpectrumBox.show();
                    MainSite.instance.dispatchResize();*/
                    showChart('polar-spectrum');
                }));
        } 

        tpul.append($('<li></li>')
            .text("Polar")
            .click((ev) => {
                tpul.children('li').removeClass('selected');
                $(ev.target).addClass("selected");
                /*spectrumBox.hide();
                polarSpectrumBox.hide();
                polarBox.show();
                MainSite.instance.dispatchResize();*/
                showChart('polar');
            }));

        tpul.append($('<li></li>')
            .text("Hovmöller")
            .click((ev) => {
                tpul.children('li').removeClass('selected');
                $(ev.target).addClass("selected");
                showChart('hovmoller');
            }));

        setTimeout(() => { //: somehow, if executed immediately, this would not display the correct box..
            tpul.children('li').eq(1).trigger('click');
        }, 500);

        const buoySensorIds = [];
        for (let sensorId in this.station.Sensors) {
            if (this.sensorId && sensorId !== this.sensorId) {
                continue;
            }

            const sensor = this.station.Sensors[sensorId];
            
            if (this.LATITUDE_PARAM_ID in sensor.Parameters) {
                buoySensorIds.push(sensorId);
            }
        }

        if (buoySensorIds.length > 0) {

            // for now this will just support a single buoy per station

            leftPanel.append($('<div class="midi_SiteObservations_dummy_header">Buoy Location</div>'));

            listeners.push(
                new ValueBox(this,
                    leftPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.Buoy_Latitude_deg, this.sensorId),
                    5, 0, 6, 48, this.ctx, false, 1.5)
            );

            listeners.push(
                new ValueBox(this,
                    leftPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.Buoy_Longitude_deg, this.sensorId),
                    12, 0, 6, 48, this.ctx, false, 1.5)
            );

            // build the buoy excursion panel
            const alerts = this.mainSite.staticDataManager.Schema.ParameterRangeEmailAlerts.filter(x => x.StationId == this.station.Station.Id && x.SensorId == buoySensorIds[0] && x.ParameterId == this.EXCURSION_PARAM_ID);
            const excursionLimit = alerts.length == 0 ? null : alerts[0].MaxValue;

            listeners.push(
                new ValueBox(this,
                    leftPanel,
                    new AlarmLimitGroupFormatter(ParameterGroupInfoSet.Buoy_Excursion_m, buoySensorIds[0], excursionLimit),
                    0, 52, 18, 48, this.ctx)
            );

        } else {
            listeners.push(
                new ValueBox(this,
                    leftPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.Total_SeaElevation_m_Mean, this.sensorId),
                    0, 0, 18, 48, this.ctx)
            );

            listeners.push(
                new ValueBox(this,
                    leftPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.Total_SeaElevation_m_Max, this.sensorId),
                    0, 52, 18, 48, this.ctx)
            );
        }

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Hs_m, this.sensorId),
                20, 0, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Hmax_m, this.sensorId),
                20, 52, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Cmax_m, this.sensorId),
                40, 0, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Cass_m, this.sensorId),
                40, 52, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Tz_s, this.sensorId),
                60, 0, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.T2_s, this.sensorId),
                60, 52, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Tp_s, this.sensorId),
                80, 0, 18, 48, this.ctx)
        );

        if (this.station.Station.Id === "NorthSea_HaeweneBrim" && this.sensorId == "SPOT-32515C") {
            listeners.push(
                new ValueBox(this,
                    leftPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.WaterTemp_degC, this.sensorId),
                    80, 52, 18, 48, this.ctx)
            );
        } else {
            listeners.push(
                new ValueBox(this,
                    leftPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.AirGap_m, this.sensorId),
                    80, 52, 18, 48, this.ctx)
            );
        }

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.MeanWaveDirection_deg, this.sensorId),
                60, 0, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.PeakWaveDirection_deg, this.sensorId),
                60, 52, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.MeanSpreading_deg, this.sensorId),
                80, 0, 18, 48, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.PeakSpreading_deg, this.sensorId),
                80, 52, 18, 48, this.ctx)
            );

        page.appendTo(container);
    }

    public renderBasic(container: JQuery, listeners: ILiveDataListener[]): void {

        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');

        var panel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '48em')
            .css('width', '64em')
            .appendTo(page);

        const buoySensorIds = [];
        for (let sensorId in this.station.Sensors) {
            const sensor = this.station.Sensors[sensorId];

            if (this.LATITUDE_PARAM_ID in sensor.Parameters) {
                buoySensorIds.push(sensorId);
            }
        }

        if (buoySensorIds.length > 0) {

            // build the buoy excursion panel
            const alerts = this.mainSite.staticDataManager.Schema.ParameterRangeEmailAlerts.filter(x => x.StationId == this.station.Station.Id && x.SensorId == buoySensorIds[0] && x.ParameterId == this.EXCURSION_PARAM_ID);
            const excursionLimit = alerts.length == 0 ? null : alerts[0].MaxValue;

            listeners.push(
                new ValueBox(this,
                    panel,
                    new AlarmLimitGroupFormatter(ParameterGroupInfoSet.Buoy_Excursion_m, null, excursionLimit),
                    66.67, 0, 32, 48, this.ctx, true, 5)
            );

        } else {
            listeners.push(
                new ValueBox(this,
                    panel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.Total_SeaElevation_m_Mean),
                    66.67, 0, 32, 48, this.ctx, true, 5)
            );
        }

        listeners.push(
            new ValueBox(this,
                panel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Hs_m),
                0, 0, 32, 48, this.ctx, true, 5)
        );

        listeners.push(
            new ValueBox(this,
                panel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Hmax_m),
                0, 52, 32, 48, this.ctx, true, 5)
        );

        listeners.push(
            new ValueBox(this,
                panel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Tz_s),
                33.33, 0, 32, 48, this.ctx, true, 5)
        );

        listeners.push(
            new ValueBox(this,
                panel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.MeanWaveDirection_deg),
                33.33, 52, 32, 48, this.ctx, true, 5)
        );

        page.appendTo(container);
    }
}